import { message } from 'antd';
import type { Rapper } from '@/components/WellLoggingOperations/types';

/*
    * Правила валидации клика.
    1. Можно рисовать, если включен режим рисование rappers
    2. Для рисования, должен быть выбран набор rappers
    3. Репер должен существовать в единственном экземпляре для скважины
    4. Клик для рисования rapper не должен происходить на другом rapper
    5. Нарисованный rapper не должен перекрывать другой rapper
*/

const enum ValidatingMessages {
    NOT_IS_DRAWING = 'Не включен режим рисования реперов',
    NOT_SELECTED_ACTIVE_PACK = 'Нужно выбрать версию реперов',
    EXIST_RAPPER_WELL = 'Репер из выбранной версии может быть только один на скважине',
    IS_INTERSECTION = 'Репер не может быть создан внутри другого репера',
    IS_OVERLAYING = 'Репер не может перекрывать другой репер',
}

const showMessage = (msg: string): void => {
    /*
        TODO: Без void TS предупреждение
    */
    void message.warning(msg);
};

/*
    Проверка на то, что значение клика не пересекается с другим rapper-ом на скважине
*/
function checkIntersection(depthValue: number, rappers: Rapper[]) {
    return rappers.some(rapper => {
        return rapper.roof < depthValue && rapper.bottom >= depthValue;
    });
}

function validateIntersection(depthValue: number, rappers: Rapper[]) {
    const isIntersection = checkIntersection(depthValue, rappers);

    if (isIntersection) {
        showMessage(ValidatingMessages.IS_INTERSECTION);
    }

    return isIntersection;
}

/*
    Проверка на то, что новый rapper не перекрывает другой rapper
*/

interface PositionClicks {
    roof: number;
    bottom: number;
}

function checkOverlying({ roof, bottom }: PositionClicks, rappers: Rapper[]) {
    return rappers.some(rapper => {
        return roof < rapper.roof && bottom > rapper.bottom;
    });
}

function validateOverlying(positionClicks: PositionClicks, rappers: Rapper[]) {
    const isOverlying = checkOverlying(positionClicks, rappers);

    if (isOverlying) {
        showMessage(ValidatingMessages.IS_OVERLAYING);
    }

    return isOverlying;
}

/*
    Проверка на то, что включен режим работы с реперами
*/
function checkIsDrawing(isDrawing: boolean) {
    if (!isDrawing) {
        showMessage(ValidatingMessages.NOT_IS_DRAWING);
    }

    return isDrawing;
}

/*
    Проверка на то, что выбрана активная версия
*/
function checkExistActivePackId(activePackId: number | null) {
    const isExist = activePackId !== null;

    if (!isExist) {
        showMessage(ValidatingMessages.NOT_SELECTED_ACTIVE_PACK);
    }

    return isExist;
}

/*
    Проверка на то, что репер существует в единственном экземпляре для скважины
*/
function checkExistRapper(activePackId: number | null, rappers: Rapper[]) {
    const isExist = rappers.some(it => Number(it.packID) === activePackId);

    if (isExist) {
        showMessage(ValidatingMessages.EXIST_RAPPER_WELL);
    }

    return isExist;
}

export const validate = {
    isDrawing: checkIsDrawing,
    existActivePackId: checkExistActivePackId,
    existRapper: checkExistRapper,
    intersection: validateIntersection,
    overlying: validateOverlying
};
